export default "__VITE_ASSET__97c9533e__"